import React from "react";
import { ArErrorKind, ArErrorViewProps } from "interfaces/ar_error.interface";
import { AR_ERROR_KINDS } from "constants/ar_error.constant";
import { STRINGS } from "constants/strings.constant";
import Assets from "imports/assets.import";
import "./ar_error_view.ui.scss";

// Retrying cannot fix a missing project or a browser that cannot run AR.
const RETRYABLE_KINDS: ArErrorKind[] = [AR_ERROR_KINDS.GENERIC, AR_ERROR_KINDS.CAMERA_DENIED];

const ArErrorView = (props: ArErrorViewProps): React.ReactElement => {
  const { kind, onRetry } = props;
  const copy = STRINGS.ar.errors[kind];

  return (
    <div className="ar_error_view" role="alert" data-error-kind={kind}>
      <div className="ar_error_view_container">
        <h2 className="ar_error_view_title">{copy.title}</h2>
        <p className="ar_error_view_message">{copy.message}</p>
        {RETRYABLE_KINDS.includes(kind) && (
          <button type="button" className="ar_error_view_retry" onClick={onRetry}>
            {STRINGS.ar.errors.retry}
          </button>
        )}
      </div>
      <img src={Assets.logo_cream} alt={STRINGS.brand.name} className="ar_error_view_brand" />
    </div>
  );
};

export default ArErrorView;
